import React, { useEffect } from 'react';
import './aboutWires.css';
import { Link } from 'react-router-dom';
import { openQuoteChat, scrollPageTop } from '../../../utils/site';
import RouteConstants from '../../../utils/RouteConstants';
import MarketingPageLayout from '../../common/layout/MarketingPageLayout';
import WiresHeroSection from './components/WiresHeroSection';
import WireBrandSection from './components/WireBrandSection';
import StatsSection from '../../common/marketing/StatsSection';
import ContentCardsSection from '../../common/marketing/ContentCardsSection';
import FaqSectionBlock from '../../common/marketing/FaqSectionBlock';
import CtaSection from '../../common/marketing/CtaSection';
import { getIndrasonPage } from '../../../data/db';
import IndrasonSeo from './components/IndrasonSeo';

const IndrasonWirePage = () => {
    useEffect(() => {
        scrollPageTop();
    }, []);

    const {
        seo,
        hero,
        brandSection,
        specsSection,
        applicationsSection,
        comparisonSection,
        faq: faqSection,
        cta: ctaSection
    } = getIndrasonPage();

    return (
        <>
            <IndrasonSeo
                seo={seo}
                faqItems={faqSection.items}
                applications={applicationsSection.items}
            />
            <MarketingPageLayout pageClassName="about-wires-page">
                <WiresHeroSection hero={hero} />
                <section className="about-wires-features">
                    <div className="container">
                        <div className="about-wires-section-header">
                            <div className="about-wires-section-subtitle">Official Brand Resource</div>
                            <h2 className="about-wires-section-title">Looking for Indrason Wire Online?</h2>
                            <p className="faq-section-desc">{seo.webPageDescription}</p>
                            <p className="faq-section-desc" style={{ marginTop: '16px' }}>
                                Compare all families on{' '}
                                <Link to={`${RouteConstants.WIRES}#wire-catalog`}>the wire collection page</Link>{' '}
                                or review the broader{' '}
                                <Link to={RouteConstants.WIRES}>NISHAD wire technology overview</Link>.
                            </p>
                        </div>
                    </div>
                </section>
                <WireBrandSection
                    sectionClassName="indrason-section"
                    sectionId="indrason-wire"
                    data={{ ...brandSection, onCtaClick: openQuoteChat }}
                    variant="indrason"
                />
                <StatsSection
                    sectionClassName="about-wires-specs"
                    header={{
                        wrapperClassName: 'about-wires-section-header',
                        subtitleClassName: 'about-wires-section-subtitle',
                        titleClassName: 'about-wires-section-title',
                        subtitle: specsSection.subtitle,
                        title: specsSection.title
                    }}
                    gridClassName="about-wires-specs-grid"
                    cardClassName="about-wires-spec-card"
                    valueClassName="about-wires-spec-value"
                    labelClassName="about-wires-spec-label"
                    items={specsSection.items}
                />
                <ContentCardsSection
                    sectionClassName="about-wires-trust"
                    header={{
                        wrapperClassName: 'about-wires-section-header',
                        subtitleClassName: 'about-wires-section-subtitle',
                        titleClassName: 'about-wires-section-title',
                        descriptionClassName: 'faq-section-desc',
                        subtitle: applicationsSection.subtitle,
                        title: applicationsSection.title,
                        description: applicationsSection.description
                    }}
                    gridClassName="about-wires-trust-grid"
                    cardClassName="about-wires-trust-card"
                    items={applicationsSection.items}
                />
                <ContentCardsSection
                    sectionClassName="about-wires-trust"
                    header={{
                        wrapperClassName: 'about-wires-section-header',
                        subtitleClassName: 'about-wires-section-subtitle',
                        titleClassName: 'about-wires-section-title',
                        subtitle: comparisonSection.subtitle,
                        title: comparisonSection.title
                    }}
                    gridClassName="about-wires-trust-grid"
                    cardClassName="about-wires-trust-card"
                    items={comparisonSection.items}
                />
                <FaqSectionBlock
                    sectionClassName="faq-section"
                    sectionId="indrason-faq"
                    header={{
                        wrapperClassName: 'about-wires-section-header',
                        subtitleClassName: 'about-wires-section-subtitle',
                        titleClassName: 'about-wires-section-title',
                        descriptionClassName: 'faq-section-desc',
                        subtitle: faqSection.subtitle,
                        title: faqSection.title,
                        description: faqSection.description
                    }}
                    faqProps={{
                        items: faqSection.items,
                        listClassName: 'faq-list',
                        itemClassName: 'faq-item',
                        questionClassName: 'faq-question',
                        questionTextClassName: 'faq-question-text',
                        iconClassName: 'faq-icon',
                        answerClassName: 'faq-answer'
                    }}
                />
                <CtaSection
                    sectionClassName="about-wires-cta"
                    title={ctaSection.title}
                    description={ctaSection.description}
                    buttonClassName="about-wires-cta-btn"
                    buttonLabel={ctaSection.buttonLabel}
                    onClick={openQuoteChat}
                />
            </MarketingPageLayout>
        </>
    );
};

export default IndrasonWirePage;
